import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Dthc, GlobalNotifications, Intent } from '../Modules';
import nullifyEmptyStrings from '../../lib/utils/nullifyEmptyStrings';
import { commitMutation, graphql } from 'react-relay';
import AccountInfoFields from './AccountInfoFields';
import { i18n } from '../../lib/utils/timezones';

export default class AccountInfo extends React.Component {

  static propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      user: _.cloneDeep(this.props.viewer),
      submitted: false
    };
    this.onFieldChange = this.onFieldChange.bind(this);
    this.resetUser = this.resetUser.bind(this);
    this.updateUser = this.updateUser.bind(this);
  }

  onFieldChange(e, name) {
    this.setState({ user: { ...this.state.user, [name]: e.target.value } });
  }

  resetUser(callback) {
    this.setState({ user: _.cloneDeep(this.props.viewer) }, callback);
  }

  updateUser(successCb, failureCb) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update account information',
        intent: Intent.DANGER
      });
      if (failureCb) failureCb();
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated account information',
        intent: Intent.SUCCESS
      });
      if (successCb) successCb();
    };

    // Set default title if null
    const localUser = nullifyEmptyStrings(this.state.user);

    const mutation = graphql`
      mutation AccountInfo_UpdateUserMutation($input: UpdateUserInput!) {
        updateUser(input: $input) {
          user {
            id
            first_name
            last_name
            company_name
            s_time_zone
          }
        }
      }
    `;

    const user = _.pick(
      localUser,
      ['id', 'first_name', 'last_name', 'company_name', 's_time_zone']
    );
    const optimisticResponse = { updateUser: { user } };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: { ...user }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  render() {
    const { viewer } = this.props;
    return (
      <Dthc
        desktop={AccountInfoFields}
        mobile={AccountInfoFields}
        localUser={this.state.user}
        onFieldChange={this.onFieldChange}
        reset={this.resetUser}
        commitUpdate={this.updateUser}
      >
        <div>
          {viewer.first_name &&
            <p>
              <strong>First Name</strong>
              <br />
              {viewer.first_name}
            </p>}
          {viewer.last_name &&
            <p>
              <strong>Last Name</strong>
              <br />
              {viewer.last_name}
            </p>}
          {viewer.company_name &&
            <p>
              <strong>Company Name</strong>
              <br />
              {viewer.company_name}
            </p>}
          <p>
            <strong>Time Zone</strong>
            <br />
            {i18n[viewer.s_time_zone] || viewer.s_time_zone}
          </p>
        </div>
      </Dthc>

    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/App/AccountInfo.js